import type { ResolverInput, ResolverResult } from './types';

// Reads progress.has_commission_tracking from the parent-fetched
// get_setup_progress snapshot. True when any public.users row for this
// business has commission_type <> 'none' (or the user explicitly skipped
// the item). §1.7.X consolidation removed the per-resolver RPC fetch — see
// SETUP_ITEMS_CONTRACT_v1.md Rule 1.
export async function resolveCommissionTrackingItem(
  { progress }: ResolverInput,
): Promise<ResolverResult> {
  if (progress.has_commission_tracking) {
    return { complete: true, reason: 'commission configured on at least one user' };
  }
  return { complete: false, reason: 'no commission configured yet' };
}
